import React, { useState } from "react";
import { Button, CardBody, Input } from "reactstrap";
import withStyles from "isomorphic-style-loader/withStyles";
import styles from "../../styles.scss";
import SectionLabel from "../../common/sectionLabel";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faRefresh } from "@fortawesome/free-solid-svg-icons";
import TooltipColorPicker from "../../common/tooltipColorPicker";

const EmailBodySection = () => {
  const [giveButtonLabel, setGiveButtonLabel] = useState("Give Now");
  const [giveButtonColor, setGiveButtonColor] = useState("#F05C22");

  return (
    <CardBody>
      <div className={styles.section}>
        <SectionLabel
          label="Logo"
          tooltip="Change the logo and add the logo you want for your charity"
          subtitle="Max. size 300×200 px. Format SVG, JPG, PNG."
        />
        <div className={styles.logoPreview}>
          <img
            src="https://placehold.co/300x200/000000/FFFFFF/png"
            alt="Logo Preview"
          />
        </div>
        <Button
          color="primary"
          outline
          size="sm"
          className={styles.changeButton}
        >
          <FontAwesomeIcon icon={faRefresh} className="me-1" />
          Change image
        </Button>
      </div>

      <div className={styles.section}>
        <SectionLabel
          label="Give Button label"
          tooltip="Change the text of your 'Give' button"
        />
        <Input
          type="text"
          value={giveButtonLabel}
          onChange={e => setGiveButtonLabel(e.target.value)}
          className={styles.input}
        />
        <SectionLabel
          label="Give Button color"
          tooltip="Personalize the color of the 'Give' button"
        />
        <TooltipColorPicker
          value={giveButtonColor}
          setValue={setGiveButtonColor}
        />
      </div>
    </CardBody>
  );
};

export default withStyles(styles)(EmailBodySection);
